import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoute';
import './web.config'; // For URL rewrite
// Global Styles
import './css/styles.scss';
// Routes
import LoginStack from './screens/LoginStack';
import BatchSchedule from './screens/StudentScreens/Dashboard/BatchSchedule';
import DigitalDoubt from './screens/DigitalDoubtCounter/DoubtTopics';
import DoubtQuestions from './screens/DigitalDoubtCounter/DoubtQuestions';
import HomePage from './screens/StudentScreens/HomePage';
import DigitalClassroomLayout from './screens/StudentScreens/DigitalClassroomStack/DigitalClassLayout';
import DigitalLecture from './screens/StudentScreens/DigitalClassroomStack/DigitalLecture';
import ClassMaterial from './screens/StudentScreens/ClassMaterialStack/ClassMaterialLayout';
import RaceNExercise from './screens/StudentScreens/RaceNExercise';
import Homework from './screens/StudentScreens/HomeworkStack/Homework';
import LiveClasses from './screens/LiveClasses';
import Layout from './components/Layout/index';
import QuestionSolution from './screens/StudentScreens/RaceNExercise/QuestionSolution';
import AddOnClassesLayout from './screens/StudentScreens/AddOnClassesStack/AddOnClassesLayout';
// import AddOnClassLecture from './screens/StudentScreens/AddOnClassesStack/AddOnClassLecture';
import CbseClassesLayout from './screens/StudentScreens/CbseClassesStack/CbseClassesLayout';
// import CbseClassesLecture from './screens/StudentScreens/CbseClassesStack/CbseClassesLecture';
import DownloadMaterial from './screens/StudentScreens/DownloadStack/DownloadLayout';
import DigitalLiveClassRecordings from './screens/StudentScreens/DigitalLiveClassRecordings/LiveClassLayout';
import VideoDetails from './components/VideoDetails';
import AnalysisScreen from './screens/StudentScreens/TestPerformanceAnalysis/AnalysisScreen';
import NoticeBoard from './screens/StudentScreens/NoticeBoard';
import RegularExamCalendar from './screens/StudentScreens/RegularExamCalendar';
import TestPerformanceAnalysis from './screens/StudentScreens/TestPerformanceAnalysis';
import PerformanceReport from './screens/StudentScreens/PerformanceReport';
import PrintPerformanceReport from './screens/StudentScreens/PerformanceReport/PrintPerformanceReport';
import LiveWebinar from './screens/StudentScreens/LiveWebinarStack';
import Textmessages from './screens/StudentScreens/TextMessages';
import ExamHall from './screens/StudentScreens/ExamHall';
import ExamSolutions from './screens/StudentScreens/ExamHall/ExamSolutions';
import LiveDoubtClass from './screens/StudentScreens/LiveDoubtClass';
import GroupNotification from './screens/StudentScreens/GroupNotification';

const Entrypoint = () => {
  return (
    <Switch>
      <ProtectedRoutes exact path="/">
        <Layout banner={false} homepage={true} component={<HomePage />} />
      </ProtectedRoutes>
      {/* Auth */}
      <Route exact path="/login" component={LoginStack} />
      <Route exact path="/login/forgot-password" component={LoginStack} />
      <Route exact path="/login/generate-password" component={LoginStack} />
      <Route exact path="/login/verify-otp" component={LoginStack} />
      {/*Batch Class Schedule*/}
      <ProtectedRoutes exact path="/batch-class-schedule">
        <Layout component={<BatchSchedule />} />
      </ProtectedRoutes>
      {/* Digital Classroom */}
      <ProtectedRoutes exact path="/digital-classroom">
        <Layout component={<DigitalClassroomLayout />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/digital-classroom/:unique/:module?">
        <Layout banner={false} component={<DigitalLecture />} />
      </ProtectedRoutes>
      {/* Digital Live Classes */}
      <ProtectedRoutes exact path="/live-class-recordings">
        <Layout component={<DigitalLiveClassRecordings />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/live-class-recordings/:unique/:module?">
        <Layout banner={false} component={<VideoDetails />} />
      </ProtectedRoutes>
      {/* Add on Classes */}
      <ProtectedRoutes exact path="/addon-classes">
        <Layout component={<AddOnClassesLayout />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/addon-classes/:unique/:module?">
        <Layout component={<VideoDetails />} />
      </ProtectedRoutes>
      {/* Cbse Classes */}
      <ProtectedRoutes exact path="/cbse-classes">
        <Layout component={<CbseClassesLayout />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/cbse-classes/:unique/:module?">
        <Layout component={<VideoDetails />} />
      </ProtectedRoutes>
      {/* Digital Doubt Counter */}
      <ProtectedRoutes exact path="/digital-doubt-counter">
        <Layout component={<DigitalDoubt />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/digital-doubt-counter/:forumCode/:forumId">
        <Layout  component={<DoubtQuestions />}/>
      </ProtectedRoutes>
      {/* Classroom Material*/}
      <ProtectedRoutes exact path="/classroom-material">
        <Layout component={<ClassMaterial />} />
      </ProtectedRoutes>
      {/*Race And Excercise */}
      <ProtectedRoutes exact path="/exercise-race">
        <Layout component={<RaceNExercise />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/exercise-race/:workBook">
        <Layout banner={false} component={<QuestionSolution />} />
      </ProtectedRoutes>
      {/* Homework*/}
      <ProtectedRoutes exact path="/homework">
        <Layout component={<Homework />} />
      </ProtectedRoutes>
      {/* Live Classes*/}
      <ProtectedRoutes exact path="/digital-liveclass">
        <Layout component={<LiveClasses />} />
      </ProtectedRoutes>
      {/* Live Webinar*/}
      <ProtectedRoutes exact path="/live-webinar">
        <Layout component={<LiveWebinar />} />
      </ProtectedRoutes>
      {/* Live Webinar*/}
      <ProtectedRoutes exact path="/live-doubt-class">
        <Layout component={<LiveDoubtClass />} />
      </ProtectedRoutes>
      {/* Download */}
      <ProtectedRoutes exact path="/download-material">
        <Layout component={<DownloadMaterial />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/regular-exam-calendar">
        <Layout banner={false} component={<RegularExamCalendar />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/test-performance-analysis">
        <Layout banner={false} component={<TestPerformanceAnalysis />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/test-performance-analysis/:testID">
        <Layout banner={false} component={<AnalysisScreen />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/performance-report">
        <Layout banner={false} component={<PerformanceReport />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/performance-report/print">
        <Layout component={<PrintPerformanceReport />} />
      </ProtectedRoutes>
      {/* Notice Board */}
      <ProtectedRoutes exact path="/notice-board">
        <Layout component={<NoticeBoard />} />
      </ProtectedRoutes>
      {/* Text Message */}
      <ProtectedRoutes exact path="/text-messages">
        <Layout component={<Textmessages />} />
      </ProtectedRoutes>
      {/* Exam Hall */}
      <ProtectedRoutes exact path="/exam-hall">
        <Layout component={<ExamHall />} />
      </ProtectedRoutes>
      <ProtectedRoutes exact path="/exam-hall/:testID">
        <Layout component={<ExamSolutions />} />
      </ProtectedRoutes>
      {/* Text Message */}
      <ProtectedRoutes exact path="/group-notifications">
        <Layout component={<GroupNotification />} />
      </ProtectedRoutes>
    </Switch>
  );
};

export default Entrypoint;
